export class ListRestoreTemplatesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "RestoreTemplateFilterConditions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListRestoreTemplatesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
